import { CogIcon, FileClockIcon } from "lucide-react";

interface BottomNavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const BottomNavigation = ({ activeTab, onTabChange }: BottomNavigationProps) => {
  const navItems = [
    { id: 'clock', icon: FileClockIcon, label: 'FileClock' },
    { id: 'settings', icon: CogIcon, label: 'Settings' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 border-t border-border bg-nav-background px-6 py-4 shadow-soft">
      <div className="flex justify-around items-center max-w-sm mx-auto">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => onTabChange(item.id)}
            aria-label={item.label}
            className={`
              flex items-center justify-center p-3 transition-all duration-300
              ${activeTab === item.id 
                ? 'text-nav-active scale-110' 
                : 'text-nav-item hover:text-nav-active hover:scale-105'
              }
            `}
          >
            <item.icon className="w-6 h-6" />
          </button>
        ))}
      </div>
    </nav>
  );
};

export default BottomNavigation;